
import {
  Component,
  PropSync,
  Vue,
  Emit,
  Prop
} from "vue-property-decorator";
import moment from "moment";
import { ServingLine, ServingType } from "@/models";
import { MealCountDtoViewModel, mcLabels } from '@/view-models';
import { mcLogger } from '@/utils';
import { types } from "@/store";

@Component
export default class McServe extends Vue {
  @PropSync("mealCounts", { type: Object }) mealCountsSync!: MealCountDtoViewModel;
  @Prop({default: 1}) public serveIncrement!: number

  private console: Console = mcLogger.getConsole(this.constructor.name, 'lime');

  labels = mcLabels.mealCounts.serve;

  siteAppYear() {
      const appInfo = this.$store.getters[types.state.siteAppDates];

      const targetSiteId: number = this.$store.state.counter.selectedSiteId || -1; // Have to have '|| -1' or else it will complain that you can't have null for an index value
      const targetProgramId: string = this.$store.state.counter.selectedProgramId || ""; // Stops linting error about null index values
      const targetDate = moment(this.$store.state.counter.selectedMealDate);
      const targetYear: number = targetDate.year();
      const targetDayOfYear: number = targetDate.dayOfYear();

      const siteAppInfos = appInfo.filter(
        o => o.siteId === targetSiteId && o.programId === targetProgramId
      );

      if (siteAppInfos.length > 0) {
        let apps = siteAppInfos.filter(siteAppInfo => siteAppInfo.programYearId == targetYear && siteAppInfo.years.some(y => y.days.some(d => d.day === targetDayOfYear)))
                                .map(siteAppInfo => siteAppInfo.programYearId)
                                .filter(this.onlyUnique);
        if (apps.length > 0) {
          return apps[0];
        }
      }
      return null;
  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  //TODO: This is repeated in mc-waste, can we put it somewhere central?
  get servingLineSummaries() {
    let result: ServingLine[] = [];
    if (this.mealCountsSync) {
      result = this.mealCountsSync.nonUserServingLines;
    }
    return result;
  }

  @Emit("input-changed")
  inputChanged() {
    const date = moment.utc().format();
    this.mealCountsSync.mealCounts.versionDateTimeUtc = date;
    let userServingLine = this.mealCountsSync.userServingLine;
    if (userServingLine) {
      userServingLine.modifiedDateTimeUtc = date;
    }

    return this.mealCountsSync.mealType;
  }

  private get countsComparison() {
    const mealCountCalc = this.mealCountsSync.tally;
    const servingLineSummary = this.mealCountsSync.servingLineSummary;

    return mealCountCalc.totalCountWithWaste >= mealCountCalc.availableCount || (servingLineSummary.additionalMealsRequested > 0);
  }
}

